import { render, staticRenderFns } from "./create-resource-btn.vue?vue&type=template&id=390f42bc"
import script from "./create-resource-btn.vue?vue&type=script&lang=js"
export * from "./create-resource-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports